var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4520E6;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Band-token_blue-violet-token",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo2-Copy-3",
    transform: "translate(276.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "st1",
    d: "M319.6,331.3c0,45.4-36.3,82.4-80.8,82.4h-155l161.1-164.1C286.5,252.8,319.6,288,319.6,331.3 L319.6,331.3z M63.3,239.3V49.6h180.5c3.1,0,6.1,0.2,9.1,0.5L63.3,239.3z M356.1,133.4c0-38.3-18.8-72.2-47.5-93.1l77.6-77.9 l-46.5,0.3L278,24.6c-11.4-3.8-23.6-5.9-36.3-5.9H29.4v301.9L285.1,63.9c23,14.5,38.4,40.2,38.4,69.5c0,45.2-36.6,82-81.7,82H235 L-49.5,500.9h46.2l55.8-56h189.3c63.1,0,114.4-51.5,114.4-114.8c0-41.7-22.4-78.2-55.7-98.3C333.8,211.8,356.1,175.2,356.1,133.4 L356.1,133.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandIcon);
export default __webpack_public_path__ + "static/media/band_icon.a6a79ecbc4fcb9548d9b1d30fdf89f88.svg";
export { ForwardRef as ReactComponent };